var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2962_75165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42578 0.943848C5.45934 0.943848 4.67578 1.72741 4.67578 2.69385V27.1938C4.67578 28.1603 5.45934 28.9438 6.42578 28.9438H23.0508C24.0172 28.9438 24.8008 28.1603 24.8008 27.1938V7.94385L17.8008 0.943848H6.42578Z",
    fill: "#E2E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5508 7.94385H24.8008L17.8008 0.943848V6.19385C17.8008 7.16028 18.5843 7.94385 19.5508 7.94385Z",
    fill: "#9DACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2383 9.69385H18.2383C18.4798 9.69385 18.6758 9.88985 18.6758 10.1313C18.6758 10.3728 18.4798 10.5688 18.2383 10.5688H11.2383C10.9968 10.5688 10.8008 10.3728 10.8008 10.1313C10.8008 9.88985 10.9968 9.69385 11.2383 9.69385Z",
    fill: "#9DACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61328 18.8813H20.8633C21.1048 18.8813 21.3008 19.0773 21.3008 19.3188C21.3008 19.5603 21.1048 19.7563 20.8633 19.7563H8.61328C8.37178 19.7563 8.17578 19.5603 8.17578 19.3188C8.17578 19.0773 8.37178 18.8813 8.61328 18.8813Z",
    fill: "#9DACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61328 24.1313H15.6133C15.8548 24.1313 16.0508 24.3273 16.0508 24.5688C16.0508 24.8103 15.8548 25.0063 15.6133 25.0063H8.61328C8.37178 25.0063 8.17578 24.8103 8.17578 24.5688C8.17578 24.3273 8.37178 24.1313 8.61328 24.1313Z",
    fill: "#9DACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61328 21.5063H20.8633C21.1048 21.5063 21.3008 21.7023 21.3008 21.9438C21.3008 22.1853 21.1048 22.3813 20.8633 22.3813H8.61328C8.37178 22.3813 8.17578 22.1853 8.17578 21.9438C8.17578 21.7023 8.37178 21.5063 8.61328 21.5063Z",
    fill: "#9DACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61328 16.2563H20.8633C21.1048 16.2563 21.3008 16.4523 21.3008 16.6938C21.3008 16.9353 21.1048 17.1313 20.8633 17.1313H8.61328C8.37178 17.1313 8.17578 16.9353 8.17578 16.6938C8.17578 16.4523 8.37178 16.2563 8.61328 16.2563Z",
    fill: "#9DACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61328 13.6313H20.8633C21.1048 13.6313 21.3008 13.8273 21.3008 14.0688C21.3008 14.3103 21.1048 14.5063 20.8633 14.5063H8.61328C8.37178 14.5063 8.17578 14.3103 8.17578 14.0688C8.17578 13.8273 8.37178 13.6313 8.61328 13.6313Z",
    fill: "#9DACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5508 7.94385L23.6677 12.0607C23.833 12.2252 23.9258 12.4488 23.9258 12.682V27.1938C23.9258 27.6773 23.5342 28.0688 23.0508 28.0688H7.30078C6.81734 28.0688 6.42578 28.4604 6.42578 28.9438H23.0508C24.0172 28.9438 24.8008 28.1603 24.8008 27.1938V7.94385H19.5508Z",
    fill: "#C9D5E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2962_75165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.738281 0.943848)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.3561db03319aff29d3f75208c32bc2d8.svg";
export { ForwardRef as ReactComponent };